import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import SgIcon from "./img/197496.png";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import newLogo from "../src/img/sl_long_new_logo_wo_beta.png";
import "./NewHomepage.css";
import "./MarketingRebrand.css";

const MAIN_NAV_ITEMS = [
  { label: "Partner with us", path: "/partner-with-us" },
  { label: "FAQ", path: "/frequentlyaskedquestions" },
  { label: "News & Events", path: "/news-events" },
  { label: "Contact Us", path: "/contactus" },
];

const HomeHeader = ({ variant = "new-homepage" }) => {
  const history = useHistory();
  const [openMenu, setOpenMenu] = useState(false);
  const location = useLocation();

  const [screenWidth, setScreenWidth] = useState(1920);
  const [screenHeight, setScreenHeight] = useState(1280);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const navigateTo = (path) => {
    history.push(path);
    window.scrollTo(0, 0);
    setOpenMenu(false);
  };

  const isNavActive = (path) =>
    path === "/news-events"
      ? location.pathname.startsWith("/news-events")
      : location.pathname === path;

  if (variant !== "legacy") {
    return (
      <>
        <header className="slMarketingTopbar">
          <div className="slMarketingHeaderInner">
            <img
              src={newLogo}
              alt="SmartLend"
              className="slMarketingLogo"
              onClick={() => navigateTo("/home")}
            />

          {screenWidth > 960 ? (
            <>
              <nav className="slMarketingNav" aria-label="Marketing navigation">
                {MAIN_NAV_ITEMS.map((item) => (
                  <button
                    key={item.path}
                    type="button"
                    className={isNavActive(item.path) ? "active" : ""}
                    onClick={() => navigateTo(item.path)}
                  >
                    {item.label}
                  </button>
                ))}
              </nav>

              <div className="slMarketingHeaderActions">
                <button
                  className="slBtn"
                  type="button"
                  onClick={() => navigateTo("/auth/signin")}
                >
                  Sign in
                </button>
                <button
                  className="slBtn slBtnPrimary"
                  type="button"
                  onClick={() => navigateTo("/auth/signup")}
                >
                  Get started
                </button>
              </div>
            </>
          ) : (
            <button
              className="slMobileMenuButton"
              type="button"
              onClick={() => setOpenMenu(true)}
              aria-label="Open menu"
            >
              <MenuIcon style={{ fontSize: 32 }} />
            </button>
          )}
          </div>
        </header>

        {openMenu && (
        <div className="slMobilePanel">
          <button
            style={{ background: "transparent", border: "none", alignSelf: "flex-end" }}
            onClick={() => setOpenMenu(false)}
            aria-label="Close menu"
          >
            <CloseIcon style={{ fontSize: 35 }} />
          </button>

          <img
            src={newLogo}
            alt="SmartLend"
            style={{ height: "70px", width: "max-content", objectFit: "contain", cursor: "pointer" }}
            onClick={() => navigateTo("/home")}
          />

          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {MAIN_NAV_ITEMS.map((item) => (
              <button
                key={item.path}
                type="button"
                onClick={() => navigateTo(item.path)}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  border: "none",
                  fontSize: "16px",
                  fontWeight: isNavActive(item.path) ? 700 : 500,
                  color:
                    isNavActive(item.path)
                      ? "#7057F6"
                      : "rgba(0,0,0,0.75)",
                  padding: "10px 0",
                }}
              >
                {item.label}
              </button>
            ))}

            <button
              className="slBtn slBtnPrimary"
              type="button"
              onClick={() => navigateTo("/auth/signup")}
            >
              Get started
            </button>
          </div>
        </div>
        )}
      </>
    );
  }

  return (
    <header className="nh-header">
      <div className="nh-wrap nh-headerInner">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "85%",
          }}
        >
          <div
            style={{
              width: screenWidth > 1200 ? "30%" : "70%",
              display: "flex",
              alignItems: "center",
            }}
          >
            {screenWidth > 1200 ? (
              <img
                src={newLogo}
                alt="SmartLend"
                style={{ height: "58px", objectFit: "contain" }}
                className="menu_button"
                onClick={() => navigateTo("/home")}
              />
            ) : (
              <img
                src={newLogo}
                alt="SmartLend"
                style={{ width: "100%", objectFit: "contain" }}
                className="menu_button"
                onClick={() => navigateTo("/home")}
              />
            )}
          </div>
          {screenWidth > 1200 ? (
            <div
              style={{
                width: "70%",
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                fontSize: "12px",
              }}
            >
              <div
                className="menu_button"
                onClick={() => navigateTo("/home")}
                style={{
                  fontWeight: location.pathname === "/home" ? "700" : "500",
                  color:
                    location.pathname === "/home"
                      ? "#256199"
                      : "rgba(0,0,0,0.7)",
                }}
              >
                Home
              </div>

              <div
                className="menu_button"
                onClick={() => navigateTo("/partner-with-us")}
                style={{
                  fontWeight:
                    location.pathname === "/partner-with-us" ? "700" : "500",
                  color:
                    location.pathname === "/partner-with-us"
                      ? "#256199"
                      : "rgba(0,0,0,0.7)",
                }}
              >
                {screenWidth > 1280 ? "Partner With Us" : "Partners"}
              </div>
              <div
                className="menu_button"
                onClick={() => navigateTo("/frequentlyaskedquestions")}
                style={{
                  fontWeight:
                    location.pathname === "/frequentlyaskedquestions"
                      ? "700"
                      : "500",
                  color:
                    location.pathname === "/frequentlyaskedquestions"
                      ? "#256199"
                      : "rgba(0,0,0,0.7)",
                }}
              >
                {screenWidth > 1280 ? "Frequently Asked Questions" : "FAQ"}
              </div>
              <div
                className="menu_button"
                onClick={() => navigateTo("/news-events")}
                style={{
                  fontWeight:
                    location.pathname === "/news-events" ? "700" : "500",
                  color:
                    location.pathname === "/news-events"
                      ? "#256199"
                      : "rgba(0,0,0,0.7)",
                }}
              >
                News & Events
              </div>
              <div
                className="menu_button"
                onClick={() => navigateTo("/contactus")}
                style={{
                  fontWeight:
                    location.pathname === "/contactus" ? "700" : "500",
                  color:
                    location.pathname === "/contactus"
                      ? "#256199"
                      : "rgba(0,0,0,0.7)",
                }}
              >
                {screenWidth > 1280 ? "Contact Us" : "Contact"}
              </div>
              <hr
                style={{
                  width: "2px",
                  height: "20px",
                  margin: "0px",
                  outline: "none",
                  border: "none",
                  background: "rgba(0,0,0,0.3)",
                }}
              />
              <div
                className="menu_button"
                onClick={() => navigateTo("/auth/signin")}
                style={{
                  fontSize: "14px",
                  fontWeight: "700",
                  color: "white",
                  border: "2px solid #256199",
                  background: "#256199",
                  padding: "5px 40px",
                  borderRadius: "15px",
                }}
              >
                Sign In
              </div>
              <div
                className="menu_button"
                onClick={() => navigateTo("/")}
                style={{
                  fontSize: "14px",
                  fontWeight: "700",
                  color: "#256199",
                  border: "none",
                  background: "white",
                  padding: "5px 15px 5px 5px",
                  boxShadow: "0px 0px 10px rgba(0,0,0,0.3)",
                  borderRadius: "15px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <img
                  src={SgIcon}
                  alt="Singapore"
                  style={{ height: "18px", marginRight: "10px" }}
                />
                <div>SG</div>
              </div>
            </div>
          ) : (
            <button
              onClick={() => setOpenMenu(true)}
              style={{ background: "transparent", border: "none" }}
            >
              <MenuIcon style={{ fontSize: 35 }} />
            </button>
          )}
          <div
            style={{
              width: screenWidth,
              height: screenHeight,
              position: "fixed",
              background: "white",
              zIndex: 200,
              top: 0,
              left: openMenu ? 0 : screenWidth,
              transition: "0.3s all ease-in-out",
            }}
          >
            <button
              style={{ background: "transparent", border: "none" }}
              onClick={() => setOpenMenu(false)}
            >
              <CloseIcon
                style={{
                  fontSize: 35,
                  position: "absolute",
                  top: 30,
                  right: 30,
                }}
              />
            </button>
            <div
              style={{
                margin: "30px 0px 0px 20px",
                width: "calc(100% - 40px)",
              }}
            >
              <div
                style={{
                  fontWeight: "700",
                  fontSize: "35px",
                  color: "#256199",
                }}
                onClick={() => navigateTo("/home")}
              >
                SmartLend.
              </div>
              {MAIN_NAV_ITEMS.map((item) => (
                <div key={item.path}>
                  <button
                    onClick={() => navigateTo(item.path)}
                    style={{
                      fontWeight: "500",
                      color: "rgba(0,0,0,0.7)",
                      marginTop: "15px",
                      background: "transparent",
                      border: "none",
                    }}
                  >
                    {item.label}
                  </button>
                </div>
              ))}
              <div style={{ display: "flex" }}>
                <button
                  onClick={() => navigateTo("/auth/signin")}
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: "white",
                    border: "2px solid #256199",
                    background: "#256199",
                    padding: screenWidth > 1200 ? "5px 40px" : "10px 20px",
                    borderRadius: "15px",
                    marginTop: "30px",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  Sign In
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HomeHeader;
